<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="fas fa-podcast" class="q-mb-sm" /> {{ $t(title_podcasts) }}
		</div>

		<filters
			class="filter-card"
			:options="getOptionsFilter"
			@requestFiltered="requestFiltered"
			@clearAndRequest="clearAndRequest"
		/>

		<q-table
			:data="podcasts"
			:columns="columns"
			:pagination.sync="server_pagination"
			@request="request"
			:loading="loading"
			:filter="filter"
			row-key="id"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
		>
			<template slot="top" slot-scope="props" :props="props">
				<q-search
					v-model="filter"
					:debounce="600"
					icon="fas fa-search"
					:placeholder="$t('search')"
				/>

				<div class="col" />
				<!-- <q-btn-dropdown
					color="secondary"
					:label="$t('reports_bi')"
					class="q-mr-sm"
					ref="dropdownReport"
					v-if="report_list.length > 0 && permissions.reports"
				>
					<q-list highlight separator link>
						<q-item
							v-for="(report, index) in report_list"
							:key="`i${index}`"
							@click.native="showReportBI(report)"
						>
							<q-item-main>
								{{ $t(report.slug) }}
							</q-item-main>
						</q-item>
					</q-list>
				</q-btn-dropdown> -->
				<q-btn
					color="secondary"
					v-if="permissions.reports"
					class="q-mr-sm"
					icon="fas fa-download"
					:disabled="$buttonDelay('podcasts_report_button_delay')"
					:label="$t('podcast_report')"
					@click="downloadReport()"
				>
					<q-tooltip
						v-if="$buttonDelay('podcasts_report_button_delay')"
						anchor="top middle"
						self="bottom middle"
						:offset="[10, 10]"
					>
						{{ $t('report_button_delay') }}
					</q-tooltip>
				</q-btn>
				<q-btn
					color="secondary"
					icon="fas fa-plus"
					:label="$t('new')"
					@click="$router.push({ name: 'admin_podcast', params: { id: 0 } })"
					:disable="!permissions.podcasts_manage"
				/>
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props" v-show="col.show">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props" :props="props">
				<q-td auto-width key="id" :props="props" v-show="showColumn(props.colsMap, 'id')">
					{{ props.row.id }}
				</q-td>

				<q-td key="title" :props="props" v-show="showColumn(props.colsMap, 'title')">
					{{ props.row.title }}
				</q-td>

				<q-td
					key="permission"
					:props="props"
					v-show="showColumn(props.colsMap, 'permission')"
				>
					<q-btn
						color="primary"
						text-color="white"
						:label="getQuantity(props.row.permission)"
						no-ripple
					>
						<q-tooltip>
							<p v-if="props.row.permission.areas.length > 0" class="tooltip q-mb-sm">
								{{ $t('areas') }}:
								<span
									v-for="(area, index) in props.row.permission.areas"
									:key="index"
								>
									{{ getArea(area) }}
									<span v-if="props.row.permission.areas.length - 1 > index"
										>,
									</span>
								</span>
							</p>
							<p
								v-if="props.row.permission.clients.length > 0"
								class="tooltip q-mb-sm"
							>
								{{ $t('clients') }}:
								<span
									v-for="(client, index) in props.row.permission.clients"
									:key="index"
								>
									{{ getClient(client) }}
									<span v-if="props.row.permission.clients.length - 1 > index"
										>,
									</span>
								</span>
							</p>
							<p
								v-if="props.row.permission.user_groups.length > 0"
								class="tooltip q-mb-sm"
							>
								{{ $t('user_groups') }}:
								<span
									v-for="(user_group, index) in props.row.permission.user_groups"
									:key="index"
								>
									{{ getUserGroup(user_group) }}
									<span v-if="props.row.permission.user_groups.length - 1 > index"
										>,
									</span>
								</span>
							</p>
							<p
								v-if="props.row.permission.profiles.length > 0"
								class="tooltip q-mb-sm"
							>
								{{ $t('profiles') }}:
								<span
									v-for="(profile, index) in props.row.permission.profiles"
									:key="index"
								>
									{{ getUserProfile(profile) }}
									<span v-if="props.row.permission.profiles.length - 1 > index"
										>,
									</span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
				</q-td>

				<q-td key="tags" :props="props" v-show="showColumn(props.colsMap, 'tags')">
					<q-btn
						color="primary"
						text-color="white"
						:label="getQuantityTags(props.row.tags)"
						no-ripple
					>
						<q-tooltip v-if="props.row.tags.length > 0">
							<p class="tooltip q-mb-sm">
								{{ $t('tags') }}:
								<span v-for="(tag, index) in props.row.tags" :key="index">
									{{ getTag(tag) }}
									<span v-if="props.row.tags.length - 1 > index">, </span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
				</q-td>

				<q-td
					key="qty_podcast_playlist_audio"
					:props="props"
					v-show="showColumn(props.colsMap, 'qty_podcast_playlist_audio')"
				>
					{{ props.row.qty_podcast_playlist_audio }}
				</q-td>

				<q-td
					key="created_date"
					:props="props"
					v-show="showColumn(props.colsMap, 'created_date')"
				>
					{{ props.row.created_date }}
				</q-td>

				<q-td
					key="updated_date"
					:props="props"
					v-show="showColumn(props.colsMap, 'updated_date')"
				>
					{{ props.row.updated_date }}
				</q-td>

				<q-td
					key="unpublish_date"
					:props="props"
					v-show="showColumn(props.colsMap, 'unpublish_date')"
				>
					{{ props.row.unpublish_date }}
				</q-td>

				<q-td
					key="status"
					:props="props"
					auto-width
					v-show="showColumn(props.colsMap, 'status')"
				>
					<q-chip
						small
						:icon="getIconStatus(props.row)"
						:color="getColorStatus(props.row)"
						class="full-width"
					>
						{{ $t(getStatus(props.row)) }}
					</q-chip>
				</q-td>

				<q-td
					auto-width
					key="actions"
					:props="props"
					v-show="showColumn(props.colsMap, 'actions')"
				>
					<q-btn
						flat
						round
						color="primary"
						icon="fas fa-pencil-alt"
						@click="
							$router.push({
								name: 'admin_podcast',
								params: { id: props.row.actions },
							})
						"
					>
						<q-tooltip>
							{{ $t('view_or_edit_tooltip') }}
						</q-tooltip>
					</q-btn>
					<q-btn
						flat
						round
						v-if="permissions.reports"
						color="secondary"
						icon="fas fa-chart-line"
						@click="showPodcastReport(props.row)"
					>
						<q-tooltip>
							{{ $t('view_report_for_this_podcast_tooltip') }}
						</q-tooltip>
					</q-btn>
					<q-btn
						flat
						round
						color="negative"
						icon="far fa-trash-alt"
						@click="confirmRemove(props.row.actions)"
						:disable="!permissions.podcasts_manage"
					>
						<q-tooltip>
							{{ $t('delete_tooltip') }}
						</q-tooltip>
					</q-btn>
				</q-td>
			</q-tr>

			<q-tr slot="bottom-row" slot-scope="props" :props="props">
				<q-td colspan="100%">
					<q-btn
						flat
						round
						dense
						color="secondary"
						size="small"
						icon="fas fa-cog"
						@click="show_customize_columns = true"
					>
						<q-tooltip>
							{{ $t('configure_table_tooltip') }}
						</q-tooltip>
					</q-btn>
				</q-td>
			</q-tr>
		</q-table>

		<q-modal
			v-model="show_customize_columns"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="saveColumns()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('personalize_columns') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-md">
						<div
							class="col-xs-12 col-sm-4"
							v-for="(column, index) in columns"
							:key="index"
							v-if="column.label && column.label != '#'"
						>
							<q-checkbox
								v-model="column.show"
								:label="$t(column.label)"
							/>
						</div>
					</div>

					<div class="row reverse gutter-md q-mt-md">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								icon="fas fa-times"
								color="primary"
								class="fit"
								:label="$t('close')"
								@click="saveColumns()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="confirm_remove" @ok="removeItem">
			<span slot="title">{{ $t('remove_item') }}</span>

			<span slot="message">{{ $t('confirm_remove_item') }}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
				<q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
			</template>
		</q-dialog>

		<q-modal
			v-model="show_report"
			:content-css="{ minWidth: '100vw', maxWidth: '100vw', minHeight: '100vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('reports') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div style="position:relative; width:100%; height:0px; padding-bottom:56.25%;">
						<iframe
							style="position:absolute; left:0; top:0; width:100%; height:100%"
							:src="report_url"
							frameborder="0"
						>
						</iframe>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_report"
			:content-css="{ minWidth: '100vw', maxWidth: '100vw', minHeight: '100vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('reports') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div style="position:relative; width:100%; height:0px; padding-bottom:56.25%;">
						<iframe
							style="position:absolute; left:0; top:0; width:100%; height:100%"
							:src="report_url"
							frameborder="0"
						>
						</iframe>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="show_report_problem" prevent-close>
			<span slot="title">{{ $t('report_download_failed') }}</span>

			<div slot="message">
				<span class="q-pa-xs">{{ $t('report_download_failed_exceeded_time') }}</span>
				<p class="q-pa-xs">{{ $t('the_report_it_will_be_sent_to_your_email') }}</p>
			</div>

			<template slot="buttons" slot-scope="props" :props="props" class="justify-center">
				<div class="row full-width q-mb-xs">
					<q-btn
						color="positive"
						class="offset-4 col-4"
						:label="$t('ok')"
						@click="show_report_problem = false"
					/>
				</div>
			</template>
		</q-dialog>

		<reports
			v-if="show_report_podcast"
			:show_report_podcast="show_report_podcast"
			:id="action_id"
			:status="action_status"
			:title="action_title"
			@hide_report="hideReport()"
		/>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import Filters from 'components/admin/podcasts/Filters.vue'
import { LocalStorage } from 'quasar'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'podcasts', 'admin', 'imports'] },

	components: {
		reports: () => import('components/admin/podcasts/Report.vue'),
		filters: Filters,
	},

	data() {
		return {
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			loading: false,
			podcasts: [],
			columns: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: true,
					show: true,
				},
				{
					name: 'title',
					required: true,
					label: 'podcast',
					align: 'left',
					field: 'title',
					sortable: true,
					show: true,
				},
				{
					name: 'permission',
					required: true,
					label: 'permissions',
					align: 'left',
					field: 'permission',
					sortable: false,
					show: false,
				},
				{
					name: 'tags',
					required: true,
					label: 'tags',
					align: 'left',
					field: 'tags',
					sortable: false,
					show: true,
				},
				{
					name: 'qty_podcast_playlist_audio',
					required: true,
					label: 'audios',
					align: 'left',
					field: 'qty_podcast_playlist_audio',
					sortable: true,
					show: true,
				},
				{
					name: 'created_date',
					required: true,
					label: 'created_date',
					align: 'left',
					field: 'created_date',
					sortable: false,
					show: true,
				},
				{
					name: 'updated_date',
					required: true,
					label: 'updated_date',
					align: 'left',
					field: 'updated_date',
					sortable: false,
					show: true,
				},
				{
					name: 'unpublish_date',
					required: true,
					label: 'unpublish_date',
					align: 'left',
					field: 'unpublish_date',
					sortable: true,
					show: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
					show: true,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'right',
					field: 'edit',
					sortable: false,
					show: true,
				},
			],
			filter: '',
			filter_area: [],
			filter_profile: [],
			filter_status: [],
			filter_tag: [],
			filter_start_date: [],
			filter_end_date: [],
			action_id: '',
			action_status: '',
			action_title: '',
			confirm_remove: false,
			show_report: false,
			report_url: '',
			dropdown_reports: false,
			show_report_podcast: false,
			show_report_problem: false,
			show_customize_columns: false,
			permissions: {
				podcasts_manage: false,
				reports: false,
			},
			show_report: false,
			report_list: [],
			report_url: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			reload_content: 'common/reload_content',
			user_clients: 'common/user_clients',
			areas: 'registration_lists/country_areas',
			user_groups: 'registration_lists/group_users',
			profiles: 'registration_lists/profiles',
			tags: 'registration_lists/tags',
			reports: 'registration_lists/reports',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			user_client_module_items: 'common/user_client_module_items',
			num_rows: 'datatable/num_rows',
			podcasts_columns: 'datatable_columns/podcasts_columns',
			reports_store: 'registration_lists/reports',
		}),

		getOptionsFilter() {
			return {
				areas: this.areas ? this.areas : [],
				profiles: this.profiles ? this.profiles : [],
				statuses: [
					{ value: 1, label: this.$t('published') },
					{ value: 2, label: this.$t('unpublished') },
				],
				tags: this.tags ? this.tags : [],
			}
		},

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		filteredReports() {
			let obj = this.reports.filter((obj) => {
				return (
					obj.slug_type === 'podcasts' &&
					obj.url != 'https://www.take5.com.br' &&
					obj.url != ''
				)
			})
			return obj
		},

		title_podcasts() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					return obj.title_podcasts === '' ? 'podcasts' : obj.title_podcasts
				}
			}
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				area: this.filter_area,
				profile: this.filter_profile,
				status: this.filter_status,
				tag: this.filter_tag,
				start_date: this.filter_start_date,
				end_date: this.filter_end_date,
				search: this.filter,
				ordering: order_by,
			}

			this.savePagination()

			this.$axios
				.get(
					`/admin_podcast/podcasts/?${this.$qs.stringify(data, {
						arrayFormat: 'repeat',
					})}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count

					this.podcasts = response.data.results.map((r) => {
						return {
							...r,
							actions: r.id,
							created_date: date.formatDate(r.created_date, 'DD/MM/YYYY HH:mm'),
							updated_date: date.formatDate(r.updated_date, 'DD/MM/YYYY HH:mm'),
							unpublish_date: r.unpublish_date
								? moment(r.unpublish_date)
										.tz('Etc/GMT')
										.format('DD/MM/YYYY')
								: '',
							permission: {
								areas: r.areas,
								profiles: r.profiles,
								clients: r.clients,
								user_groups: r.user_groups,
							},
						}
					})

					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		fetchLists() {
			this.$q.loading.show()

			this.$axios
				.get('/accounts/get_registration_lists/', this.getHeader)
				.then((response) => {
					this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		showColumn(list, name) {
			if (list[name]) return list[name].show
			else return false
		},

		saveColumns() {
			this.show_customize_columns = false
			this.saveDatatableColumns()
		},

		showPodcastReport(podcast) {
			this.action_id = podcast.id
			this.action_status = podcast.status
			this.action_title = podcast.title
			this.show_report_podcast = true
		},

		hideReport() {
			this.action_id = ''
			this.show_report_podcast = false
			this.loadPagination()
		},

		confirmRemove(id) {
			this.action_id = id
			this.confirm_remove = true
		},

		removeItem() {
			this.$q.loading.show()

			this.$axios
				.delete(`/admin_podcast/podcasts/${this.action_id}/`, this.getHeader)
				.then((response) => {
					this.$q.loading.hide()

					this.request({
						pagination: this.server_pagination,
					})

					this.confirm_remove = false

					this.$q.notify({
						message: this.$t('item_removed_success'),
						type: 'positive',
						icon: 'far fa-trash-alt',
					})
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getStatus(row) {
			if (row.status == 1) return 'published'
			else if (row.status == 2) return 'unpublished'
			else if (row.status == 3) return 'deleted'
			else if (row.status == 4) return 'processing'
			else if (row.status == 5) return 'processing'
		},

		getIconStatus(row) {
			if (row.status == 1) return 'fas fa-check'
			else if (row.status == 2) return 'fas fa-ban'
			else if (row.status == 3) return 'fas fa-trash-alt'
			else if (row.status == 4) return 'fas fa-sync fa-spin'
			else if (row.status == 5) return 'fas fa-sync fa-spin'
		},

		getColorStatus(row) {
			if (row.status == 1) return 'positive'
			else if (row.status == 2) return 'warning'
			else if (row.status == 3) return 'negative'
			else if (row.status == 4) return 'info'
			else if (row.status == 5) return 'info'
		},

		getQuantity(permission) {
			return (
				permission.areas.length +
				permission.clients.length +
				permission.user_groups.length +
				permission.profiles.length
			)
		},

		getArea(area) {
			let obj = this.areas.find((obj) => {
				return obj.value === area
			})
			if (obj) return obj.label
			else return ''
		},

		getClient(client) {
			if (this.user_clients) {
				let obj = this.user_clients.find((obj) => {
					return obj.id === client
				})
				if (obj) return obj.name
			}
			return ''
		},

		getUserGroup(user_group) {
			let obj = this.user_groups.find((obj) => {
				return obj.value === user_group
			})
			if (obj) return obj.label
			else return ''
		},

		getUserProfile(profile) {
			let obj = this.profiles.find((obj) => {
				return obj.value === profile
			})
			if (obj) return obj.label
			else return ''
		},

		getQuantityTags(tags) {
			return tags.length > 0 ? tags.length : '0'
		},

		getTag(tag) {
			let obj = this.tags.find((obj) => {
				return obj.value === tag
			})
			if (obj) return obj.label
			else return ''
		},

		showReport(report) {
			this.report_url = report.url
			this.dropdown_reports = false
			this.show_report = true
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		saveDatatableColumns() {
			this.$store.dispatch('datatable_columns/SET_PODCASTS_COLUMNS', [this.columns])
		},

		loadDatatableColumns() {
			if (this.$compareStoredColumns(this.columns, this.podcasts_columns))
				this.columns = this.podcasts_columns
			else return
		},

		downloadReport() {
			if (this.$buttonDelay('podcasts_report_button_delay')) return
			let message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(`admin_podcast/podcasts/generate_report/`, this.getHeader)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					this.show_report_problem = true
					console.log(e)
				})
				.finally(() => {
					this.$store.dispatch('common/SET_PODCASTS_REPORT_BUTTON_DELAY', [new Date()])
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		clearAndRequest() {
			this.filter_area = []
			this.filter_profile = []
			this.filter_status = []
			this.filter_tag = []
			this.filter_start_date = []
			this.filter_end_date = []

			this.request({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: this.num_rows,
					descending: false,
					sortBy: null,
				},
			})
		},

		requestFiltered({ area, profile, status, tag, start_date, end_date }) {
			;(this.filter_area = area), (this.filter_profile = profile)
			this.filter_status = status
			this.filter_tag = tag
			this.filter_start_date = start_date
			this.filter_end_date = end_date

			this.request({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: this.num_rows,
					descending: false,
					sortBy: null,
				},
			})
		},

		checkPermissions() {
			const client = this.user_client_module_items.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (client) {
				for (const [key, value] of Object.entries(this.permissions)) {
					let obj = client.module_items.find((obj) => obj.slug === key)
					if (obj) {
						this.permissions[key] = obj.permission
					}
				}
			} else return
		},

		loadReports() {
			if (this.reports_store)
				this.report_list = this.reports_store.filter((obj) => {
					return (
						obj.slug_type === 'podcasts' &&
						obj.url != 'https://www.take5.com.br' &&
						obj.url != ''
					)
				})
		},

		getAuthParamsData(url_original) {
			this.$q.loading.show()
			this.$axios
				.get('/reports/reports/get_looker_studio_challenge_token/', this.getHeader)
				.then((response) => {
					this.report_url = `${url_original}?${response.data.params}`
					this.show_report = true
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		showReportBI(report) {
			this.$refs.dropdownReport.hide()
			if (report.report_type === 3) {
				this.getAuthParamsData(report.url_original)
			} else {
				this.report_url = report.url
				this.show_report = true
			}
		},
	},

	watch: {
		reload_content: function() {
			this.request({
				pagination: this.server_pagination,
			})
		},
	},

	created() {
		this.loadReports()
		this.loadDatatableColumns()
		this.loadPagination()
		this.checkPermissions()

		this.request({
			pagination: this.server_pagination,
		})
	},
}
</script>

<style lang="stylus" scoped>
.filter-card
    border-radius 4px
    box-shadow 0 1px 2px rgba(0,0,0,0.2), 0 1px 1px rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12)
</style>
